// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"108":"0656af5d","184":"3d3eb989","236":"37ede74a","258":"ef08a35c","270":"ef08a35c","966":"923ae7ed"}[chunkId] + ".css";
};